module.exports = __webpack_public_path__ + "img/systempicforimpvis.1f0d16c6.png";